import { ForexHistoryItem } from '@/feature/TrHistory/api/forex-history.interface';
import { mapForexBuyCreatedDraft } from '@/feature/TrHistory/api/form/forex-form.utils';

export const mapForexHistoryList = (
	list?: ForexHistoryItem[] | null
): ForexHistoryItem[] => (list || [])
	.map(item => Object.assign(mapForexBuyCreatedDraft(item), {
		loaded: false
	}));
